import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = ({ tokenType }) => {
  const auth = localStorage.getItem(
    tokenType === "expert" ? "EXPERT_AUTH_TOKEN" : "USER_AUTH_TOKEN"
  );
  return auth ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
